import { Injectable, effect, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notifications$ = new BehaviorSubject<any[]>([]);
  constructor() {

  }

}
